import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ProjectFavorite, Project } from 'core';

@Injectable({
  providedIn: 'root'
})
export class FavoritesService {

baseUrl = environment.apiEndpoint + '/project/';

constructor(private http: HttpClient) { }

  setProjectFavorite(id: string) {
    return this.http.post<ProjectFavorite>(this.baseUrl +  id + '/favorite', {});
  }

  removeProjectFavorite(id: string) {
    return this.http.delete<ProjectFavorite>(this.baseUrl +  id + '/favorite', {});
  }

  getProjectFavorites(forceRefresh = false) {
    return this.http.get<any>(this.baseUrl + 'favorites',  {
      headers : {cache : '1', refresh: forceRefresh ? '1' : '0' }
    });
  }
}
